import axios from "axios";

// Em desenvolvimento o backend corre à parte (porta 8001). Publicada, a app é servida pelo próprio
// backend, por isso usa o mesmo endereço (BACKEND vazio → pedidos para /api).
const BACKEND = (
  process.env.REACT_APP_BACKEND_URL ?? (process.env.NODE_ENV === "production" ? "" : "http://localhost:8001")
).replace(/\/$/, "");
const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Algo correu mal. Tenta novamente.";
  // If passed an axios error, extract the detail from response.data
  if (detail && typeof detail === "object" && detail.isAxiosError) {
    const d = detail.response?.data?.detail;
    if (d != null) return formatError(d);
    return detail.message || "Erro de rede.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export { API };
export default api;
